module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "goods-list-page"
    }
  }, [_c('div', {
    staticClass: "breadcrumb wrapper",
    staticStyle: {
      "line-height": "30px"
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', [_vm._v("搜索结果")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.regionName))])]), _vm._v(" "), _c('div', {
    staticClass: "container wrapper clearfix"
  }, [(_vm.landmarkTreeData) ? _c('lefe-tree', {
    attrs: {
      "data": _vm.landmarkTreeData
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right",
    attrs: {
      "id": "result"
    }
  }, [_c('div', {
    staticClass: "shop_con_list",
    attrs: {
      "id": "main-nav-holder"
    }
  }, [_c('nav', {
    staticClass: "sort-bar",
    attrs: {
      "id": "main-nav"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "desc",
      "name": "order"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sortbar-array"
  }, [_vm._v(" 排序方式：\n            "), _c('ul', [_c('li', {
    class: {
      selected: _vm.search_type == 0
    },
    on: {
      "click": function($event) {
        return _vm.searchByType(0)
      }
    }
  }, [_c('a', {
    class: {
      'desc': _vm.order == 'order',
      'asc': _vm.order == 'asc'
    },
    attrs: {
      "href": "javascript:void(0)",
      "title": "点击按默认从低到高排序"
    }
  }, [_vm._v("\n                  默认"), _c('i')])]), _vm._v(" "), _c('li', {
    class: {
      selected: _vm.search_type == 1
    },
    on: {
      "click": function($event) {
        return _vm.searchByType(1)
      }
    }
  }, [_c('a', {
    class: {
      'desc': _vm.order == 'order',
      'asc': _vm.order == 'asc'
    },
    attrs: {
      "href": "javascript:void(0)",
      "title": "点击按销量从高到低排序"
    }
  }, [_vm._v("\n                  销量"), _c('i')])]), _vm._v(" "), _c('li', {
    class: {
      selected: _vm.search_type == 2
    },
    on: {
      "click": function($event) {
        return _vm.searchByType(2)
      }
    }
  }, [_c('a', {
    class: {
      'desc': _vm.order == 'order',
      'asc': _vm.order == 'asc'
    },
    attrs: {
      "href": "javascript:void(0)",
      "title": "点击按价格从高到低排序"
    }
  }, [_vm._v("\n                  价格"), _c('i')])])])])]), _vm._v(" "), (!this.loading && this.list.length == 0) ? _c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "20px",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_vm._v("\n          抱歉,暂无此类商品!\n        ")]) : _vm._e(), _vm._v(" "), _c('right-goods', {
    attrs: {
      "data": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total>0"
    }],
    staticClass: "page-wrapper"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.page,
      "page-size": _vm.pageSize,
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40b09864"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landmark-superior-product/landmark-goods-list.vue
// module id = 1585
// module chunks = 1